import React, { useState, useCallback, useEffect } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import { Card, Txt, Icon, IconButton } from '../../../../../../components'
import { useTheme } from '../../../../../../theming/ThemeProvider'
import useStyles from './useStyles'
import TractorForm from '../TractorForm'
const TractorCard = (props) => {
  const { recurringTractor, day, onChangeValue } = props

  const [prefixes, setPrefixes] = useState({})
  const { theme } = useTheme()
  const styles = useStyles(theme)
  const [editing, setEditing] = useState(false)

  useEffect(() => {
    setPrefixes({
      tractors: `tractors_available_${day.name}`,
      equipmentType: `equipment_type_id_${day.name}`,
      teams: `teams_${day.name}`
    })
  }, [day])

  const onSaveTractor = useCallback((newTractor) => {
    onChangeValue(prefixes.tractors, newTractor.available)
    onChangeValue(prefixes.equipmentType, newTractor.equipmentType)
    onChangeValue(prefixes.teams, newTractor.teams)
    setEditing(false)
  }, [onChangeValue, prefixes])

  const onRemoveTractor = useCallback((newTractor) => {
    onChangeValue(prefixes.tractors, 0)
    onChangeValue(prefixes.equipmentType, null)
    onChangeValue(prefixes.teams, '0')
    setEditing(false)
  }, [onChangeValue, prefixes])

  return (
    <View>
      <Card containerStyle={styles.card} contentStyle={styles.cardContent}>
        {editing ? (
          <TractorForm
            day={day}
            recurringTractor={recurringTractor}
            onSave={onSaveTractor}
          />
        ) : (
          <View style={styles.details}>
            <View style={styles.tractors}>
              <Txt
                text={`${day.label}:`}
                identity='body2Bold'
              />
              <Txt
                text={recurringTractor[prefixes.tractors] || 0}
                identity='body2'
                numberOfLines={1}
                style={styles.tractorsNumber}
              />
            </View>
            <View style={styles.equipment}>
              <Icon
                name='Tractors'
                height={16}
                width={16}
                fill={theme.AZTEC}
              />
              <Txt
                text={recurringTractor[prefixes.equipmentType] ? recurringTractor[prefixes.equipmentType].description : '- -'}
                identity='body2'
                color='SLATE_GRAY'
                style={styles.text}
              />
            </View>
            <View style={styles.teams}>
              {Boolean(recurringTractor[prefixes.teams]) && (
                <Txt
                  text='Team'
                  identity='body2Bold'
                  color='LOCHMARA'
                />
              )}
            </View>
            <View style={styles.actions}>
              <IconButton
                icon='Edit2'
                onPress={() => setEditing(true)}
                color='WHITE'
                iconColor='OUTER_SPACE'
              />
              <IconButton
                icon='Delete'
                onPress={onRemoveTractor}
                color='WHITE'
                iconColor='OUTER_SPACE'
              />
            </View>
          </View>
        )}
      </Card>
    </View>
  )
}

TractorCard.propTypes = {
  recurringTractor: PropTypes.object,
  day: PropTypes.object,
  onChangeValue: PropTypes.func
}

TractorCard.defaultProps = {
  recurringTractor: {},
  day: {},
  onChangeValue: () => {}
}

export default TractorCard
